import React, { useState, useRef, useEffect, useCallback } from 'react';
import './CustomPhoneInput.css';

/* ------------------------------------------------------------------
   Country data – preferred countries shown first, rest alphabetical
   ------------------------------------------------------------------ */
const ALL_COUNTRIES = [
  // Preferred (shown at top)
  { code: 'in', name: 'India',                dialCode: '+91',  flag: '🇮🇳' },
  { code: 'bd', name: 'Bangladesh',           dialCode: '+880', flag: '🇧🇩' },
  { code: 'pk', name: 'Pakistan',             dialCode: '+92',  flag: '🇵🇰' },
  { code: 'sa', name: 'Saudi Arabia',         dialCode: '+966', flag: '🇸🇦' },
  { code: 'ae', name: 'United Arab Emirates', dialCode: '+971', flag: '🇦🇪' },
  { code: 'gb', name: 'United Kingdom',       dialCode: '+44',  flag: '🇬🇧' },
  { code: 'us', name: 'United States',        dialCode: '+1',   flag: '🇺🇸' },
  { code: 'sg', name: 'Singapore',            dialCode: '+65',  flag: '🇸🇬' },
  // Rest – alphabetical
  { code: 'af', name: 'Afghanistan',          dialCode: '+93',  flag: '🇦🇫' },
  { code: 'al', name: 'Albania',              dialCode: '+355', flag: '🇦🇱' },
  { code: 'dz', name: 'Algeria',              dialCode: '+213', flag: '🇩🇿' },
  { code: 'ao', name: 'Angola',               dialCode: '+244', flag: '🇦🇴' },
  { code: 'ar', name: 'Argentina',            dialCode: '+54',  flag: '🇦🇷' },
  { code: 'am', name: 'Armenia',              dialCode: '+374', flag: '🇦🇲' },
  { code: 'au', name: 'Australia',            dialCode: '+61',  flag: '🇦🇺' },
  { code: 'at', name: 'Austria',              dialCode: '+43',  flag: '🇦🇹' },
  { code: 'az', name: 'Azerbaijan',           dialCode: '+994', flag: '🇦🇿' },
  { code: 'bh', name: 'Bahrain',              dialCode: '+973', flag: '🇧🇭' },
  { code: 'be', name: 'Belgium',              dialCode: '+32',  flag: '🇧🇪' },
  { code: 'bj', name: 'Benin',                dialCode: '+229', flag: '🇧🇯' },
  { code: 'bt', name: 'Bhutan',               dialCode: '+975', flag: '🇧🇹' },
  { code: 'bo', name: 'Bolivia',              dialCode: '+591', flag: '🇧🇴' },
  { code: 'ba', name: 'Bosnia and Herzegovina',dialCode: '+387',flag: '🇧🇦' },
  { code: 'bw', name: 'Botswana',             dialCode: '+267', flag: '🇧🇼' },
  { code: 'br', name: 'Brazil',               dialCode: '+55',  flag: '🇧🇷' },
  { code: 'bn', name: 'Brunei',               dialCode: '+673', flag: '🇧🇳' },
  { code: 'bg', name: 'Bulgaria',             dialCode: '+359', flag: '🇧🇬' },
  { code: 'bf', name: 'Burkina Faso',         dialCode: '+226', flag: '🇧🇫' },
  { code: 'kh', name: 'Cambodia',             dialCode: '+855', flag: '🇰🇭' },
  { code: 'cm', name: 'Cameroon',             dialCode: '+237', flag: '🇨🇲' },
  { code: 'ca', name: 'Canada',               dialCode: '+1',   flag: '🇨🇦' },
  { code: 'cf', name: 'Central African Republic',dialCode: '+236',flag:'🇨🇫'},
  { code: 'td', name: 'Chad',                 dialCode: '+235', flag: '🇹🇩' },
  { code: 'cl', name: 'Chile',                dialCode: '+56',  flag: '🇨🇱' },
  { code: 'cn', name: 'China',                dialCode: '+86',  flag: '🇨🇳' },
  { code: 'co', name: 'Colombia',             dialCode: '+57',  flag: '🇨🇴' },
  { code: 'cd', name: 'Congo (DRC)',           dialCode: '+243', flag: '🇨🇩' },
  { code: 'cg', name: 'Congo (Republic)',      dialCode: '+242', flag: '🇨🇬' },
  { code: 'cr', name: 'Costa Rica',           dialCode: '+506', flag: '🇨🇷' },
  { code: 'hr', name: 'Croatia',              dialCode: '+385', flag: '🇭🇷' },
  { code: 'cu', name: 'Cuba',                 dialCode: '+53',  flag: '🇨🇺' },
  { code: 'cy', name: 'Cyprus',               dialCode: '+357', flag: '🇨🇾' },
  { code: 'cz', name: 'Czech Republic',       dialCode: '+420', flag: '🇨🇿' },
  { code: 'dk', name: 'Denmark',              dialCode: '+45',  flag: '🇩🇰' },
  { code: 'ec', name: 'Ecuador',              dialCode: '+593', flag: '🇪🇨' },
  { code: 'eg', name: 'Egypt',                dialCode: '+20',  flag: '🇪🇬' },
  { code: 'sv', name: 'El Salvador',          dialCode: '+503', flag: '🇸🇻' },
  { code: 'et', name: 'Ethiopia',             dialCode: '+251', flag: '🇪🇹' },
  { code: 'fi', name: 'Finland',              dialCode: '+358', flag: '🇫🇮' },
  { code: 'fr', name: 'France',               dialCode: '+33',  flag: '🇫🇷' },
  { code: 'ga', name: 'Gabon',                dialCode: '+241', flag: '🇬🇦' },
  { code: 'gm', name: 'Gambia',               dialCode: '+220', flag: '🇬🇲' },
  { code: 'ge', name: 'Georgia',              dialCode: '+995', flag: '🇬🇪' },
  { code: 'de', name: 'Germany',              dialCode: '+49',  flag: '🇩🇪' },
  { code: 'gh', name: 'Ghana',                dialCode: '+233', flag: '🇬🇭' },
  { code: 'gr', name: 'Greece',               dialCode: '+30',  flag: '🇬🇷' },
  { code: 'gt', name: 'Guatemala',            dialCode: '+502', flag: '🇬🇹' },
  { code: 'gn', name: 'Guinea',               dialCode: '+224', flag: '🇬🇳' },
  { code: 'gy', name: 'Guyana',               dialCode: '+592', flag: '🇬🇾' },
  { code: 'ht', name: 'Haiti',                dialCode: '+509', flag: '🇭🇹' },
  { code: 'hn', name: 'Honduras',             dialCode: '+504', flag: '🇭🇳' },
  { code: 'hu', name: 'Hungary',              dialCode: '+36',  flag: '🇭🇺' },
  { code: 'id', name: 'Indonesia',            dialCode: '+62',  flag: '🇮🇩' },
  { code: 'ir', name: 'Iran',                 dialCode: '+98',  flag: '🇮🇷' },
  { code: 'iq', name: 'Iraq',                 dialCode: '+964', flag: '🇮🇶' },
  { code: 'ie', name: 'Ireland',              dialCode: '+353', flag: '🇮🇪' },
  { code: 'il', name: 'Israel',               dialCode: '+972', flag: '🇮🇱' },
  { code: 'it', name: 'Italy',                dialCode: '+39',  flag: '🇮🇹' },
  { code: 'ci', name: 'Ivory Coast',          dialCode: '+225', flag: '🇨🇮' },
  { code: 'jm', name: 'Jamaica',              dialCode: '+1876',flag: '🇯🇲' },
  { code: 'jp', name: 'Japan',                dialCode: '+81',  flag: '🇯🇵' },
  { code: 'jo', name: 'Jordan',               dialCode: '+962', flag: '🇯🇴' },
  { code: 'kz', name: 'Kazakhstan',           dialCode: '+7',   flag: '🇰🇿' },
  { code: 'ke', name: 'Kenya',                dialCode: '+254', flag: '🇰🇪' },
  { code: 'kw', name: 'Kuwait',               dialCode: '+965', flag: '🇰🇼' },
  { code: 'kg', name: 'Kyrgyzstan',           dialCode: '+996', flag: '🇰🇬' },
  { code: 'la', name: 'Laos',                 dialCode: '+856', flag: '🇱🇦' },
  { code: 'lb', name: 'Lebanon',              dialCode: '+961', flag: '🇱🇧' },
  { code: 'ly', name: 'Libya',                dialCode: '+218', flag: '🇱🇾' },
  { code: 'lt', name: 'Lithuania',            dialCode: '+370', flag: '🇱🇹' },
  { code: 'lu', name: 'Luxembourg',           dialCode: '+352', flag: '🇱🇺' },
  { code: 'mg', name: 'Madagascar',           dialCode: '+261', flag: '🇲🇬' },
  { code: 'mw', name: 'Malawi',               dialCode: '+265', flag: '🇲🇼' },
  { code: 'my', name: 'Malaysia',             dialCode: '+60',  flag: '🇲🇾' },
  { code: 'mv', name: 'Maldives',             dialCode: '+960', flag: '🇲🇻' },
  { code: 'ml', name: 'Mali',                 dialCode: '+223', flag: '🇲🇱' },
  { code: 'mt', name: 'Malta',                dialCode: '+356', flag: '🇲🇹' },
  { code: 'mr', name: 'Mauritania',           dialCode: '+222', flag: '🇲🇷' },
  { code: 'mu', name: 'Mauritius',            dialCode: '+230', flag: '🇲🇺' },
  { code: 'mx', name: 'Mexico',               dialCode: '+52',  flag: '🇲🇽' },
  { code: 'md', name: 'Moldova',              dialCode: '+373', flag: '🇲🇩' },
  { code: 'mn', name: 'Mongolia',             dialCode: '+976', flag: '🇲🇳' },
  { code: 'ma', name: 'Morocco',              dialCode: '+212', flag: '🇲🇦' },
  { code: 'mz', name: 'Mozambique',           dialCode: '+258', flag: '🇲🇿' },
  { code: 'mm', name: 'Myanmar',              dialCode: '+95',  flag: '🇲🇲' },
  { code: 'na', name: 'Namibia',              dialCode: '+264', flag: '🇳🇦' },
  { code: 'np', name: 'Nepal',                dialCode: '+977', flag: '🇳🇵' },
  { code: 'nl', name: 'Netherlands',          dialCode: '+31',  flag: '🇳🇱' },
  { code: 'nz', name: 'New Zealand',          dialCode: '+64',  flag: '🇳🇿' },
  { code: 'ni', name: 'Nicaragua',            dialCode: '+505', flag: '🇳🇮' },
  { code: 'ne', name: 'Niger',                dialCode: '+227', flag: '🇳🇪' },
  { code: 'ng', name: 'Nigeria',              dialCode: '+234', flag: '🇳🇬' },
  { code: 'no', name: 'Norway',               dialCode: '+47',  flag: '🇳🇴' },
  { code: 'om', name: 'Oman',                 dialCode: '+968', flag: '🇴🇲' },
  { code: 'pa', name: 'Panama',               dialCode: '+507', flag: '🇵🇦' },
  { code: 'py', name: 'Paraguay',             dialCode: '+595', flag: '🇵🇾' },
  { code: 'pe', name: 'Peru',                 dialCode: '+51',  flag: '🇵🇪' },
  { code: 'ph', name: 'Philippines',          dialCode: '+63',  flag: '🇵🇭' },
  { code: 'pl', name: 'Poland',               dialCode: '+48',  flag: '🇵🇱' },
  { code: 'pt', name: 'Portugal',             dialCode: '+351', flag: '🇵🇹' },
  { code: 'qa', name: 'Qatar',                dialCode: '+974', flag: '🇶🇦' },
  { code: 'ro', name: 'Romania',              dialCode: '+40',  flag: '🇷🇴' },
  { code: 'ru', name: 'Russia',               dialCode: '+7',   flag: '🇷🇺' },
  { code: 'rw', name: 'Rwanda',               dialCode: '+250', flag: '🇷🇼' },
  { code: 'sn', name: 'Senegal',              dialCode: '+221', flag: '🇸🇳' },
  { code: 'rs', name: 'Serbia',               dialCode: '+381', flag: '🇷🇸' },
  { code: 'sl', name: 'Sierra Leone',         dialCode: '+232', flag: '🇸🇱' },
  { code: 'so', name: 'Somalia',              dialCode: '+252', flag: '🇸🇴' },
  { code: 'za', name: 'South Africa',         dialCode: '+27',  flag: '🇿🇦' },
  { code: 'kr', name: 'South Korea',          dialCode: '+82',  flag: '🇰🇷' },
  { code: 'ss', name: 'South Sudan',          dialCode: '+211', flag: '🇸🇸' },
  { code: 'es', name: 'Spain',                dialCode: '+34',  flag: '🇪🇸' },
  { code: 'lk', name: 'Sri Lanka',            dialCode: '+94',  flag: '🇱🇰' },
  { code: 'sd', name: 'Sudan',                dialCode: '+249', flag: '🇸🇩' },
  { code: 'se', name: 'Sweden',               dialCode: '+46',  flag: '🇸🇪' },
  { code: 'ch', name: 'Switzerland',          dialCode: '+41',  flag: '🇨🇭' },
  { code: 'sy', name: 'Syria',                dialCode: '+963', flag: '🇸🇾' },
  { code: 'tw', name: 'Taiwan',               dialCode: '+886', flag: '🇹🇼' },
  { code: 'tj', name: 'Tajikistan',           dialCode: '+992', flag: '🇹🇯' },
  { code: 'tz', name: 'Tanzania',             dialCode: '+255', flag: '🇹🇿' },
  { code: 'th', name: 'Thailand',             dialCode: '+66',  flag: '🇹🇭' },
  { code: 'tg', name: 'Togo',                 dialCode: '+228', flag: '🇹🇬' },
  { code: 'tn', name: 'Tunisia',              dialCode: '+216', flag: '🇹🇳' },
  { code: 'tr', name: 'Turkey',               dialCode: '+90',  flag: '🇹🇷' },
  { code: 'tm', name: 'Turkmenistan',         dialCode: '+993', flag: '🇹🇲' },
  { code: 'ug', name: 'Uganda',               dialCode: '+256', flag: '🇺🇬' },
  { code: 'ua', name: 'Ukraine',              dialCode: '+380', flag: '🇺🇦' },
  { code: 'uy', name: 'Uruguay',              dialCode: '+598', flag: '🇺🇾' },
  { code: 'uz', name: 'Uzbekistan',           dialCode: '+998', flag: '🇺🇿' },
  { code: 've', name: 'Venezuela',            dialCode: '+58',  flag: '🇻🇪' },
  { code: 'vn', name: 'Vietnam',              dialCode: '+84',  flag: '🇻🇳' },
  { code: 'ye', name: 'Yemen',                dialCode: '+967', flag: '🇾🇪' },
  { code: 'zm', name: 'Zambia',               dialCode: '+260', flag: '🇿🇲' },
  { code: 'zw', name: 'Zimbabwe',             dialCode: '+263', flag: '🇿🇼' },
];

const DEFAULT_COUNTRY = ALL_COUNTRIES.find(c => c.code === 'in');

/**
 * CustomPhoneInput
 *
 * Props:
 *   onChange(rawValue, countryData)
 *     rawValue    – digits only with dial code, no '+', e.g. "919876543210"
 *     countryData – { dialCode: "91", name: "India", flag: "🇮🇳" }
 *   disabled     – boolean
 *   id           – string, applied to the number input
 *   defaultCountry – country code string, e.g. 'in' (default)
 */
const CustomPhoneInput = ({ onChange, disabled, id, defaultCountry = 'in' }) => {
  const initialCountry = ALL_COUNTRIES.find(c => c.code === defaultCountry) || DEFAULT_COUNTRY;

  const [selectedCountry, setSelectedCountry] = useState(initialCountry);
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const wrapperRef = useRef(null);
  const searchRef = useRef(null);
  const numberInputRef = useRef(null);

  /* Close dropdown on outside click */
  useEffect(() => {
    const onClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
        setSearch('');
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  /* Auto-focus search when dropdown opens */
  useEffect(() => {
    if (isOpen && searchRef.current) {
      searchRef.current.focus();
    }
  }, [isOpen]);

  const emitChange = useCallback((country, number) => {
    if (!onChange) return;
    const dialDigits = country.dialCode.replace('+', '');
    const raw = dialDigits + number;          // e.g. "919876543210"
    const countryData = { dialCode: dialDigits, name: country.name, flag: country.flag };
    onChange(raw, countryData);
  }, [onChange]);

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setIsOpen(false);
    setSearch('');
    emitChange(country, phoneNumber);
    setTimeout(() => numberInputRef.current && numberInputRef.current.focus(), 50);
  };

  const handleNumberChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '');  // digits only
    setPhoneNumber(digits);
    emitChange(selectedCountry, digits);
  };

  const toggleDropdown = () => {
    if (disabled) return;
    setIsOpen(prev => {
      if (prev) setSearch('');
      return !prev;
    });
  };

  /* Filtered country list */
  const filtered = search.trim()
    ? ALL_COUNTRIES.filter(c =>
        c.name.toLowerCase().includes(search.toLowerCase()) ||
        c.dialCode.includes(search)
      )
    : ALL_COUNTRIES;

  return (
    <div className="cpi-wrapper" ref={wrapperRef}>
      {/* ---- Input row ---- */}
      <div className={`cpi-field${isOpen ? ' open' : ''}`}>
        {/* Country selector */}
        <button
          type="button"
          className="cpi-country-btn"
          onClick={toggleDropdown}
          disabled={disabled}
          aria-haspopup="listbox"
          aria-expanded={isOpen}
          aria-label={`Country: ${selectedCountry.name} ${selectedCountry.dialCode}`}
        >
          <span className="cpi-flag">{selectedCountry.flag}</span>
          <span className={`cpi-arrow${isOpen ? ' up' : ''}`}>▾</span>
        </button>

        {/* Dial code prefix */}
        <span className="cpi-dial-code">{selectedCountry.dialCode}</span>

        {/* Number input */}
        <input
          ref={numberInputRef}
          type="tel"
          className="cpi-number-input"
          value={phoneNumber}
          onChange={handleNumberChange}
          disabled={disabled}
          id={id}
          placeholder="Phone number"
          autoComplete="tel-national"
          inputMode="numeric"
        />
      </div>

      {/* ---- Dropdown ---- */}
      {isOpen && (
        <div className="cpi-dropdown" role="listbox">
          {/* Search */}
          <div className="cpi-search-wrapper">
            <span className="cpi-search-icon">🔍</span>
            <input
              ref={searchRef}
              type="text"
              className="cpi-search-input"
              placeholder="Search country..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              onKeyDown={e => {
                if (e.key === 'Escape') { setIsOpen(false); setSearch(''); }
                if (e.key === 'Enter' && filtered.length > 0) {
                  handleCountrySelect(filtered[0]);
                }
              }}
            />
          </div>

          {/* Country list */}
          <ul className="cpi-country-list">
            {filtered.length > 0 ? filtered.map((country, idx) => (
              <li
                key={`${country.code}-${idx}`}
                role="option"
                aria-selected={country.code === selectedCountry.code}
                className={`cpi-country-item${country.code === selectedCountry.code ? ' selected' : ''}`}
                onClick={() => handleCountrySelect(country)}
              >
                <span className="cpi-item-flag">{country.flag}</span>
                <span className="cpi-item-name">{country.name}</span>
                <span className="cpi-item-dial">{country.dialCode}</span>
              </li>
            )) : (
              <li className="cpi-no-results">No countries found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CustomPhoneInput;
